// extracted by mini-css-extract-plugin
module.exports = {"TableHeadings":"TableHeader_TableHeadings__1F0V-"};